import React from 'react';
import { Button } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { t } from 'helpers/i18n';
import { useHistory } from 'react-router-dom';

function PandoraPlayground() {
  const history = useHistory();

  return (
    <div>
      <Button
        icon={<LogoutOutlined />}
        onClick={() => {
          history.push(`/playground`);
        }}
      >
        {t('Pandora Playground')}
      </Button>
    </div>
  );
}

export default PandoraPlayground;
